// extracted by mini-css-extract-plugin
module.exports = {"experimental":"PortalFeatureTable_experimental_1B6IZ","remove":"PortalFeatureTable_remove_1eLh6"};